import {defineStore} from 'pinia'
import {getInvoiceSituation} from "@/services/invoiceService"

export const useInvoiceSituationStore = defineStore("invoiceSituation", {
    state: () => ({
        openInvoiceTotal: 0,
        firstInvoiceDueDate: new Date(),
        firstInvoiceIssueDate: new Date(),
        nextInvoiceDate: new Date(),
        nextInvoiceDueDate: new Date(),
        partialPayments: {},
        hasOpenInvoice: false,
        isInDebt: false
    }),
    getters: {
        getOpenInvoiceTotal(state){
            return state.openInvoiceTotal
        },
        getFirstInvoiceDueDate(state){
            return state.firstInvoiceDueDate
        },
        getFirstInvoiceIssueDate(state){
            return state.firstInvoiceIssueDate
        },
        getNextInvoiceDate(state){
            return state.nextInvoiceDate
        },
        getPartialPayments(state){
            return state.partialPayments
        },
        getInvoiceSituation(state){
            return state.hasOpenInvoice
        },
        getIsInDebt(state){
            return state.isInDebt
        }
    },
    actions: {
        async fetchInvoiceSituation() {
            const data = await getInvoiceSituation();
            if (!data) {
                return;
            }

            this.openInvoiceTotal = data.openInvoiceTotal;
            this.firstInvoiceDueDate = data.firstInvoiceDueDate ?? new Date();
            this.firstInvoiceIssueDate = data.firstInvoiceIssueDate ?? new Date();
            this.nextInvoiceDate = data.nextInvoiceDate ?? new Date();
            this.nextInvoiceDueDate = data.nextInvoiceDueDate ?? new Date();
            this.partialPayments = data.partialPayments;
            this.hasOpenInvoice = !!(data.openInvoiceTotal || data.payUrgently);
            this.isInDebt = data.isInDebt;
        }
    }
})

export type InvoiceSituationStore = ReturnType<typeof useInvoiceSituationStore>